import { actionNames } from './actions'

const mainReducer = (state = [], action) => {
  switch (action.type) {
    case actionNames.FETCH_COUNTRIES_SUCCESS: {
      return action.countries
    }
    default:
      return state
  }
}

export default mainReducer
